<template>
    <div class="input-wrapper-custom-material">
      <div class="group">
        <imask-input
          v-model="fieldValue"
          :mask="Number"
          :thousandsSeparator="userThouSep"
          :scale="scale"
          :radix="userDecSep"
          :unmask="true"
          class="mdl-textfield__input"
          :class="{ 'is-invalid': errorMessages.length > 0 }"
          placeholder=" "
          @blur="$emit('blur')"
        />
        <span class="highlight"></span>
        <span
          class="bar"
          :class="{ 'is-invalid': errorMessages.length > 0 }"
        ></span>
        <label
          class="mdl-textfield__label v-label theme--light"
          :class="{ 'is-invalid': errorMessages.length > 0 }"
          >{{ labelText }}</label
        >
      </div>
      <div v-if="errorMessages.length > 0" class="text-field__error">
        {{ errorMessages[0] }}
      </div>
    </div>
  </template>
  <script>
import { IMaskComponent } from 'vue-imask';
export default {
    data() {
        return {
            userDecSep: this.$store.getters['account/user'].MetricDecimalSep,
            userThouSep: this.$store.getters['account/user'].MetricThousandSep,
            firstTime: true
        };
    },
    props: {
        conditionItem: {
            type: Object,
            required: true
        },
        labelText: {
            type: String,
            required: true
        },
        scale: {
            type: Number,
            default: 3
        },
        errorMessages: {
            type: Array,
            default: () => []
        },
        isForSearchCriteria: {
            type: Boolean,
            default: true,
        }
    },
    components: {
        'imask-input': IMaskComponent,
    },
    computed: {
        fieldValue: {
            get() {
                return this.isForSearchCriteria ? this.searchCriteriaItemGet() : this.conditionItem.value;
            },
            set(newValue) {
                if (this.isForSearchCriteria) this.conditionItem.fieldValue = newValue;
                else this.conditionItem.value = newValue;
            },
        }
    },
    methods: {
        searchCriteriaItemGet() {
            try {
                if (this.firstTime)
                    this.formatNumberString(this.conditionItem.fieldValue, this.scale);

                this.firstTime = false;
            } catch (ex) {
                // Ignore
            }
            return this.conditionItem.fieldValue;
        },
        formatNumberString(numberString, scale) {
            // Check if the number string contains a decimal point
            const decimalIndex = numberString.indexOf('.');

            if (decimalIndex !== -1) {
                // Calculate the current number of decimal places
                const currentDecimalPlaces = numberString.length - decimalIndex - 1;

                // Only modify the string if the scale is less than the current number of decimal places
                if (scale < currentDecimalPlaces) {
                    // Truncate the string to the desired scale
                    let modifiedValue;
                    if (scale === 0) {
                        modifiedValue = numberString.substring(0, decimalIndex + scale);
                    } else {
                        modifiedValue = numberString.substring(0, decimalIndex + scale + 1);
                    }

                    this.conditionItem.value = modifiedValue;
                }
            }
        }
    },
};
  </script>
  <style lang="scss" scoped>
  $bg-color: #424242;
  $hl-color: #00cae3;
  $muted-color: mix(white, $bg-color, 70%);
  $unfocused-color: rgb(118, 118, 118);
  $invalid-color: rgb(255, 87, 86);
  $trans-time: 300ms;
  $width: 100%;

  .input-wrapper-custom-material {
    position: relative;
    display: flex;
    align-items: center;

    .group {
      flex: 1;
      position: relative;
      margin: 14px 0 10px 0;
    }
    // INPUTS
    .mdl-textfield__input {
      background: none;
      color: inherit;
      accent-color: #00cae3;
      line-height: 12px;
      font-size: 14px;
      padding: 8px 0;
      display: block;
      width: $width;
      border: none;
      border-radius: 0;
      border-bottom: 1px solid $muted-color;
      font-weight: 400;
      &:focus {
        outline: none;
      }
      &:required {
        &:focus ~ label,
        &:valid ~ label {
          top: -10px;
          font-size: 10px;
          color: $hl-color;
        }
        &:not(:focus) ~ label {
          color: $unfocused-color;
        }
        &:invalid ~ label {
          color: $invalid-color;
        }
      }
      &:not(:required) {
        &:focus ~ label,
        &:not(:placeholder-shown):valid ~ label {
          top: -10px;
          font-size: 10px;
          color: $hl-color;
        }
        &:not(:focus) ~ label,
        &:not(:placeholder-shown):valid:not(:focus) ~ label {
          color: $unfocused-color;
        }
        &.is-invalid ~ label {
            color: $invalid-color;
        }
      }
      &:focus ~ .bar:before {
        width: $width;
      }
    }
    label {
      font-size: 14px;
      position: absolute;
      pointer-events: none;
      top: 10px;
      transition: $trans-time ease all;
      color: $unfocused-color;
      font-weight: 300;
    }
    .bar {
      position: relative;
      display: block;
      width: $width;
      &:before {
        content: "";
        height: 2px;
        width: 0;
        bottom: 0px;
        position: absolute;
        background: $hl-color;
        transition: $trans-time ease all;
        left: 0%;
      }
      &.is-invalid:before {
        background: $invalid-color;
      }
    }
    .text-field__error {
      color: $invalid-color;
      font-size: 12px;
      line-height: 12px;
      word-break: break-word;
      word-wrap: break-word;
      position: absolute;
      top: 100%;
    }
    .is-invalid {
      color: $invalid-color;
    }
  }
  </style>
